import { DailyRewardFormValues } from './types';

import { REWARD_STUB, UserRole } from 'v2/constants';

export const DAILY_REWARD_FORM_INITIAL_VALUES: DailyRewardFormValues = {
  day: 0,
  description: '',
  rewards: [REWARD_STUB],
  allowedUserRoles: [UserRole.DEFAULT_USER],
};
